/* eslint-disable no-magic-numbers */

import {
  DescriptionList,
  Skeleton,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useContractor } from '@omnipresentgroup/domains';
import type { Contract } from '@omnipresentgroup/types';
import { useMemo } from 'react';

const BILLING_ENTRIES = [
  {
    key: 'billingCurrency',
    label: 'Billing currency',
  },
];

export const ContractorBillingDetails = ({
  contractorId,
}: {
  contractorId: string;
}) => {
  const { data: contractor, isLoading } = useContractor({ id: contractorId });

  const contract = useMemo(
    () => contractor?.contracts[0],
    [contractor?.contracts],
  );

  const billingDetails = useMemo(
    () =>
      BILLING_ENTRIES.map(({ label, key }) => ({
        header: label,
        detail: isLoading ? (
          <Skeleton key={key} />
        ) : (
          (contract?.[key as keyof Contract] as string | JSX.Element)
        ),
      })),
    [contract, isLoading],
  );

  return (
    <Stack data-testid="billing-details-list">
      <Typography as="h3" hideParagraphSpacing size="20" weight="medium">
        Billing details
      </Typography>
      <DescriptionList
        fraction="1/2"
        id="billing-details-list"
        list={billingDetails}
      />
    </Stack>
  );
};
